"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Colours", {
  enumerable: true,
  get: function get() {
    return _coloursConfig["default"];
  }
});
Object.defineProperty(exports, "brand", {
  enumerable: true,
  get: function get() {
    return _colourTokens.brand;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "functional", {
  enumerable: true,
  get: function get() {
    return _colourTokens.functional;
  }
});
Object.defineProperty(exports, "global", {
  enumerable: true,
  get: function get() {
    return _colourTokens.global;
  }
});
Object.defineProperty(exports, "universal", {
  enumerable: true,
  get: function get() {
    return _colourTokens.universal;
  }
});
var _colourTokens = require("./colour-tokens");
var _coloursConfig = _interopRequireDefault(require("./colours-config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var _default = exports["default"] = _coloursConfig["default"];